/* eslint-disable sort-keys */
import React from 'react';

import { createLocale } from 'locales';

import OrganisationSettingsPageContainer from 'pages/organization/OrganisationSettingsPage/components/organisation-settings-page-container';

import useOrganisationSettingsIntegrationCreate from 'state/remote/remote-organization/organisation-settings/use-organisation-settings-integration-create';

import FetchedJobFormCard from './components/fetched-job-form-card';

const localize = createLocale('organisationIntegrationSettingsLocales');

const CreateJobsPage: React.FC = () => {
  const { crumbs, formOptions, form, selectedJobs, rateRules, createdJobIds } =
    useOrganisationSettingsIntegrationCreate();

  return (
    <OrganisationSettingsPageContainer
      title={localize('selectedJobs', { count: selectedJobs.length })}
      selectedRoute={{ groupName: 'organisation', name: 'integrations' }}
      crumbs={crumbs}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {selectedJobs.map((job) => {
          const isCreated = createdJobIds.includes(job.id);
          return (
            <FetchedJobFormCard
              key={job.id}
              job={job}
              form={form}
              formOptions={formOptions}
              rateRules={rateRules}
              isCreated={isCreated}
            />
          );
        })}
      </div>
    </OrganisationSettingsPageContainer>
  );
};

export default CreateJobsPage;
